function mount({ rootElement = null }) {
  const btnToggle = rootElement.querySelector('[data-action="toggle-module-listing-helpers"]');

  btnToggle.addEventListener('click', () => {
    const helpers = document.querySelectorAll('.block-name-helper');

    [...helpers].forEach((item) => {
      item.classList.toggle('is--hidden');
    });
  });
}

function init() {
  const blocks = document.querySelectorAll('.module-helper-toggle-box');

  [...blocks].forEach((block) => {
    mount({ rootElement: block });
  });
}

export default init;
